import { render, staticRenderFns } from "./AccomTabs.vue?vue&type=template&id=73f38012&"
import script from "./AccomTabs.vue?vue&type=script&lang=js&"
export * from "./AccomTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports